module.exports = __webpack_public_path__ + "img/music-square-remove.13eb06dc.svg";